var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    { staticClass: "annotation-container" },
    [
      _c(
        "div",
        { staticClass: "flex-row mb-3" },
        [
          _c("avatar", { attrs: { avatar: _vm.data.avatar, size: "medium" } }),
          _vm._v(" "),
          _c("div", { staticClass: "ml-2 wp-10" }, [
            _c("p", { staticClass: "info" }, [
              _c("span", { staticClass: "name" }, [
                _c(
                  "a",
                  {
                    staticClass: "link",
                    attrs: { href: "/staff/" + _vm.data.owner }
                  },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.data.ownerName) +
                        "\n                    "
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "time gray-60 fs-2" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(
                      _vm.$filters.dateFormatter(
                        _vm.data.timestamp,
                        "SLASHED_DATE_TIME"
                      )
                    ) +
                    "\n                "
                )
              ])
            ]),
            _vm._v(" "),
            !_vm.fulltText
              ? _c("p", { staticClass: "m-0" }, [
                  _c("span", {
                    staticClass:
                      "content wordbreak gray-60 editor-preview rich-text-style",
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.annotationHTMLFormattedContentTruncated
                      )
                    }
                  }),
                  _vm._v(" "),
                  _vm.data.content.length > 256
                    ? _c(
                        "a",
                        {
                          staticClass: "link",
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              _vm.fulltText = true
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$l10n.__("Afficher la suite")))]
                      )
                    : _vm._e()
                ])
              : _c("p", {
                  staticClass:
                    "m-0 content wordbreak gray-60 editor-preview rich-text-style",
                  domProps: {
                    innerHTML: _vm._s(_vm.annotationHTMLFormattedContent)
                  }
                }),
            _vm._v(" "),
            _vm.data.relatedName
              ? _c("div", [
                  _c("p", { staticClass: "grey fs-2" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$l10n.__("Lié à : ")) +
                        "\n                    "
                    ),
                    _vm.data.type == "task"
                      ? _c(
                          "span",
                          {
                            staticClass: "link fs-2 regular",
                            on: {
                              click: function($event) {
                                return _vm.taskLink(_vm.data)
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.data.relatedName))]
                        )
                      : _c(
                          "a",
                          {
                            staticClass: "link fs-2 regular",
                            attrs: { href: _vm.data.relatedLink }
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.data.relatedName) +
                                "\n                    "
                            )
                          ]
                        )
                  ])
                ])
              : _vm._e()
          ])
        ],
        1
      ),
      _vm._v(" "),
      _vm.data.reply
        ? _c("div", [
            _vm.data.reply.length > 2
              ? _c("div", [
                  _c("a", {
                    staticClass: "link dinlineb ml-3 mb-3 fs-2",
                    domProps: {
                      innerHTML: _vm._s(
                        !_vm.displayAllAnnot
                          ? _vm.$t.__(
                              "dashboard.cards.Annotation.see_more_answers"
                            )
                          : _vm.$t.__(
                              "dashboard.cards.Annotation.see_less_answers"
                            )
                      )
                    },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.toggleAllAnnot()
                      }
                    }
                  })
                ])
              : _vm._e(),
            _vm._v(" "),
            !_vm.displayAllAnnot
              ? _c(
                  "ul",
                  _vm._l(_vm.last2annot, function(reply) {
                    return _c("li", { key: reply.id }, [
                      _c(
                        "div",
                        { staticClass: "reply flex-row pl-3 mb-3" },
                        [
                          _c("avatar", {
                            attrs: { avatar: reply.avatar, size: "medium" }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "ml-2 wp-10" }, [
                            _c("p", { staticClass: "info" }, [
                              _c("span", { staticClass: "name" }, [
                                _c(
                                  "a",
                                  {
                                    staticClass: "link",
                                    attrs: { href: "/staff/" + reply.owner }
                                  },
                                  [_vm._v(_vm._s(reply.ownerName))]
                                )
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "time gray-60 fs-2" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$filters.dateFormatter(
                                      reply.timestamp,
                                      "SLASHED_DATE_TIME"
                                    )
                                  )
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("p", {
                              staticClass:
                                "content my-1 wordbreak editor-preview rich-text-style",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.formatContentToHTML(reply.content)
                                )
                              }
                            })
                          ])
                        ],
                        1
                      )
                    ])
                  }),
                  0
                )
              : _c(
                  "ul",
                  _vm._l(_vm.data.reply, function(reply) {
                    return _c("li", { key: reply.id }, [
                      _c(
                        "div",
                        { staticClass: "reply flex-row pl-3 mb-3" },
                        [
                          _c("avatar", {
                            attrs: { avatar: reply.avatar, size: "medium" }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "ml-2 wp-10" }, [
                            _c("p", { staticClass: "info" }, [
                              _c("span", { staticClass: "name" }, [
                                _c(
                                  "a",
                                  {
                                    staticClass: "link",
                                    attrs: { href: "/staff/" + reply.owner }
                                  },
                                  [_vm._v(_vm._s(reply.ownerName))]
                                )
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "time gray-60 fs-2" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$filters.dateFormatter(
                                      reply.timestamp,
                                      "SLASHED_DATE_TIME"
                                    )
                                  )
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("p", {
                              staticClass:
                                "content my-1 wordbreak editor-preview rich-text-style",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.formatContentToHTML(reply.content)
                                )
                              }
                            })
                          ])
                        ],
                        1
                      )
                    ])
                  }),
                  0
                )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("RichText", {
        staticClass: "custom-richtext",
        attrs: {
          placeholder: _vm.$t.__("common.actions.answer"),
          options: _vm.optionsRichText
        },
        model: {
          value: _vm.reply.annot_text,
          callback: function($$v) {
            _vm.$set(_vm.reply, "annot_text", $$v)
          },
          expression: "reply.annot_text"
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "aright mt-2 mb-3" }, [
        _c(
          "a",
          {
            staticClass: "link",
            class: _vm.reply.annot_text.length == "" ? "hidden" : "",
            attrs: { type: "primary" },
            on: {
              click: function($event) {
                return _vm.save(_vm.currentTab)
              }
            }
          },
          [_vm._v(_vm._s(_vm.$l10n.__("Enregistrer")))]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }